export enum TaskType {
    FILE = "file",
    TRANSACTION = "transaction",
    TRANSACTIONS = "transactions",
    QUESTION = "question",
    // Onboarding tasks
    INVITE_ACCOUNTANT = "invite_accountant",
    RECEIPT_PHONE_NUMBER = "receipt_phone_number",
    // System tasks
    CONNECTION_BROKEN = "connection_broken",
    PLAID_NEW_ACCOUNTS_AVAILABLE = "plaid_new_accounts_available",
    PLAID_STATEMENTS_REFRESH = "plaid_statements_refresh",
    // Migration tasks
    MAP_CHART_OF_ACCOUNTS = "map_chart_of_accounts",
    CONNECT_ACCOUNT = "connect_account",
    MAP_MIGRATED_DATA = "map_migrated_data",
    // P&L activation task
    PROFIT_LOSS_ACTIVATION = "profit_loss_activation",
    // P&L task
    PROFIT_LOSS = "profit_loss",
    // Balance Sheet task
    BALANCE_SHEET = "balance_sheet",
    // Document retrieval task
    DOCUMENT_RETRIEVAL = "document_retrieval",
    // Get documents task (simplified document upload view)
    GET_DOCUMENTS = "get_documents",
    // Accrual review task (one per accrual suggestion bucket per entity)
    ACCRUAL_REVIEW = "accrual_review",
    // Reconciliation task
    RECONCILIATION = "reconciliation",
    FILE_MIGRATION_UPLOAD = "file_migration_upload",
    XERO_FILE_UPLOAD = "xero_file_upload",
    QBDT_FILE_UPLOAD = "qbdt_file_upload",
    // Transaction review task: sticky transactions view with review-variant columns
    TRANSACTION_REVIEW = "transaction_review",
    // 1099 review task: counterparties directory scoped to the current tax year
    FORM_1099 = "form_1099",
    // Counterparties task: counterparties directory view created from scratch or from a bulk selection
    COUNTERPARTIES = "counterparties",
    // Bills task: bills view created from scratch or from a bulk selection
    BILLS = "bills",
    // Invoices task: invoices view created from scratch or from a bulk selection
    INVOICES = "invoices",
    // Financial documents task: documents view defined by filters or a bulk selection, not by upload
    FINANCIAL_DOCUMENTS = "financial_documents",
    // Schedule close tasks (Schedules V1)
    SCHEDULE_RULE_SUGGESTED_REVIEW = "schedule_rule_suggested_review",
    SCHEDULE_SUSPICIOUS_TRANSACTION_REVIEW = "schedule_suspicious_transaction_review",
    REVENUE_RECOGNITION_REVIEW = "revenue_recognition_review",
    SCHEDULE_SOURCE_CHANGE_REVIEW = "schedule_source_change_review",
    MILESTONE_REVENUE_RECOGNITION_REVIEW = "milestone_revenue_recognition_review",
    // Integration CoA mapping task: one per entity per integration provider
    INTEGRATION_COA_MAPPING = "integration_coa_mapping",
}
